export let ClientType;
(function (ClientType) {
  ClientType["WEB_WORKER"] = "WEB_WORKER";
  ClientType["SHARED_WORKER"] = "SHARED_WORKER";
})(ClientType || (ClientType = {}));